export default __webpack_public_path__ + "static/rumpledLinens-67cbf4686bbc50475f77740b2a930b57.svg";